// Angular Core Modules
import { Component, inject, Input, input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';

// Third Party Modules
import { CardModule } from 'primeng/card';
import { PrimeTemplate } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';

// Application Modules and Utils
import { Consumer } from '@app/resources/services';
import { ExistingMemberRecentTransactionsListComponent } from '@app/areas/members/components/existing-member-recent-transactions-list/existing-member-recent-transactions-list.component';
import { ExistingMemberInformationComponent } from '@app/areas/members/components/existing-member-information/existing-member-information.component';
import { PortalTheme } from '@app/@shared/models';
import { CssValidatorService } from '@app/@shared/services/css-validator.service';

@Component({
  selector: 'app-existing-member-display-card',
  standalone: true,
  imports: [
    CardModule,
    PrimeTemplate,
    AvatarModule,
    NgIf,
    ExistingMemberRecentTransactionsListComponent,
    ExistingMemberInformationComponent,
  ],
  templateUrl: './existing-member-display-card.component.html',
  styleUrl: './existing-member-display-card.component.scss',
})
export class ExistingMemberDisplayCardComponent implements OnInit {
  private readonly cssValidatorService = inject(CssValidatorService);
  member = input.required<Consumer>();
  @Input() theme: PortalTheme | undefined;

  ngOnInit(): void {
    this.setCSSCustomProperties();
  }

  private setCSSCustomProperties(): void {
    if (this.theme) {
      // Set CSS custom properties based on the theme
      document.documentElement.style.setProperty('--primary', this.theme.primary);
      document.documentElement.style.setProperty('--header-bg-primary', this.theme.header?.backgroundColor);
      document.documentElement.style.setProperty('--form-header-text-color', this.theme.form?.header?.textColor);
      document.documentElement.style.setProperty('--form-bg-color', this.theme.form?.backgroundColor);
      document.documentElement.style.setProperty('--text--color-default', this.theme.defaultTextColor);
      // Check for undefined CSS variables
      this.cssValidatorService.checkUndefinedCssVariables('ExistingMemberDisplayCardComponent');
    }
  }
}
